<template>
  <div
    class="relative"
    :class="{
      isMobile: getIsMobile,
    }"
  >
    <div
      class="announcement"
      :class="{
        'height-35': getIsMobile,
      }"
    >
      <img class="xiaolaba" v-lazy="xiaolaba" alt="" />
      <div class="announcement-div" ref="boxWrap">
        <div class="carouselCon" ref="box">
          <div
            :index="index"
            :_id="item._id || ''"
            class="my-list"
            :class="{
              pointer: item.showPoint,
            }"
            @click="handleJump(item)"
            v-for="(item, index) in list"
            :key="index"
            :data-id="`id_` + index"
          >
            <span v-html="item.content"></span>
          </div>
          <div
            :index="index"
            :_id="item._id || ''"
            class="my-list"
            :class="{
              pointer: item.showPoint,
            }"
            @click="handleJump(item)"
            v-for="(item, index) in list"
            :key="(index + 1) * 100"
            :data-id="`id_` + index"
          >
            <span v-html="item.content"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 跳转游戏 -->
    <jpDetailDialog ref="jpDetailDialog" />
  </div>
</template>

<script>
import hTxtBanner from "@/lobby_common/mixins_components/banner/h-txt-banner.js";
import { mapGetters } from "vuex";
import jpDetailDialog from "@/views/homeModule/jpDetailDialog.vue";
export default {
  components: {
    jpDetailDialog,
  },
  props: [],
  mixins: [hTxtBanner],
  data() {
    return {};
  },
  filters: {},
  computed: {
    ...mapGetters(["getIsMobile"]),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.relative {
  &.isMobile {
    padding: 0 10px;
    margin-top: 15px;
  }
}
.announcement {
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  background: var(--background-1202);
  border: 1px solid var(--border-color-600);
  // margin-top: 10px;
  height: 35px;
  color: var(--font-color-900);
  border-radius: var(--radius-200);
  &.height-35 {
    height: 35px;
  }
  .xiaolaba {
    width: 20px;
  }
  .announcement-div {
    margin: 0 5px;
    flex: 1;
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .carouselCon {
    white-space: nowrap;
    position: absolute;
    left: 100%;
    display: flex;
    align-items: center;
    .my-list {
      margin-left: 5px;
      padding: 0 20px;
      margin-right: 25px;
      display: inline-block;
      height: 21px;
      line-height: 21px;
      font-size: 12px;
      &.pointer {
        cursor: pointer;
      }
      ::v-deep .color-light {
        color: var(--font-color-300);
        font-weight: bold;
      }
    }
  }
}
</style>
